import React, { useCallback, useContext, useRef, useState } from 'react'
import { EmptyItem, Form, Item, Label, RequiredRule } from 'devextreme-react/form'
import { FormContext } from '../../context/FormContext'
import { generateToken } from '../../api/prediagnosticoApi'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'
import TermsConditionsLabel from '../TermsConditionsLabel'
import Modal from '../Modal'
import Link from '../Link'

const submit = async (form, context) => {
  const { isValid } = form.validate()
  if (!isValid) {
    return
  }

  const { documentNumber, documentType } = form.option('formData')
  const { setAuthData, setQuestionData } = context

  form.element().classList.add('animate__fadeOutDown')

  const { token, next } = await generateToken(documentType, documentNumber)

  setAuthData({ documentNumber, documentType, token, isAuth: true })

  setQuestionData(next, 'animate__fadeInDown')
}

const optionsTipoDocumento = {
  validationMessageMode: 'always',
  placeholder: 'Tipo de documento',
  displayExpr: 'name',
  valueExpr: 'id',
  dataSource: {
    store: {
      type: 'array',
      data: [
        { id: 'CC', name: 'Cédula de ciudadanía' },
        { id: 'CE', name: 'Cédula de extranjería' },
        { id: 'P', name: 'Pasaporte' },
        { id: 'TI', name: 'Tarjeta de identidad' },
        { id: 'RC', name: 'Registro civil' },
        { id: 'NIT', name: 'NIT' },
        { id: 'NUIP', name: 'NUIP' },
        { id: 'CIE', name: 'Cédula de identidad extranjera' }
      ],
      key: 'id'
    }
  }
}
const optionsNumeroIdentificacion = {
  placeholder: 'Numero de identificación',
  validationMessageMode: 'always'
}
const optionsTerminosCondiciones = {
  validationMessageMode: 'always',
  validationMessagePosition: 'bottom'
}

const btnStyle = {
  backgroundColor: '#40c0c0'
}

const defaultFormData = {
  terms: false
}

const ClientInformationForm = () => {
  const [terms, setTerms] = useState(false)
  const formRef = useRef()
  const context = useContext(FormContext)
  const isLargeScreen = useMediaQuery('(min-width: 640px)')

  const toggleTerms = useCallback(() => {
    const form = formRef.current.instance
    const data = form.option('formData')
    if (!terms && !data.terms) {
      setTimeout(() => {
        form.option('formData', { ...data, terms: false })
      })
    }

    setTerms(terms => !terms)
  }, [terms])

  const submitCallback = useCallback(() => {
    const form = formRef.current.instance
    if (!form.validate().isValid) {
      return
    }

    return submit(form, context)
  }, [context])

  const renderLabel = useCallback(() => {
    return <TermsConditionsLabel toggleTerms={toggleTerms} />
  }, [toggleTerms])

  return (
    <>

      {
        terms && (
          <Modal toggle={toggleTerms}>
            <h2 className='text-lg font-bold mb-4'>Politica de privacidad</h2>
            <p className='mb-8'>
              De manera voluntaria, explícita, informada e inequívoca,
              <Link url='https://universidadean.edu.co/la-universidad/aviso-datos-personales' content=' autorizo a la Universidad Ean para tratar mis datos personales' />,
              de acuerdo con lo dispuesto en los artículos 5, 7 y concordantes del Decreto 1377 de 2013 y las demás disposiciones legales referentes al tema.
              Para mayor información acerca del manejo de tus datos personales, puedes revisar nuestro
              <Link url='https://universidadean.edu.co/la-universidad/aviso-de-privacidad' content=' Aviso de privacidad ' />
              y nuestra <Link url='https://universidadean.edu.co/la-universidad/aviso-datos-personales' content='Política de tratamiento de datos personales. ' />
            </p>
            <button className='text-white font-bold py-2 px-4 rounded' onClick={toggleTerms} style={btnStyle}>
              Cerrar
            </button>
          </Modal>
        )
      }

      <Form ref={formRef} width='100%' colCount={10} onEditorEnterKey={submitCallback} defaultFormData={defaultFormData}>
        <Item colSpan={6} editorOptions={optionsNumeroIdentificacion} dataField='documentNumber' editorType='dxTextBox'>
          <RequiredRule message='Por favor, ingresa tu numero de identificación.' />
          <Label visible={false} />
        </Item>
        <Item colSpan={4} editorOptions={optionsTipoDocumento} dataField='documentType' editorType='dxSelectBox'>
          <RequiredRule message='Por favor, selecciona tu tipo de documento.' />
          <Label visible={false} />
        </Item>
        <EmptyItem colSpan={6} />
        <Item colSpan={4} cssClass='font-bold text-gray-600 text-3xl cCheckbox' editorOptions={optionsTerminosCondiciones} editorType='dxCheckBox' dataField='terms'>
          <RequiredRule message='' />
          <Label text='Acepto los términos y condiciones' location='left' render={renderLabel} />
        </Item>
      </Form>
      <div className='flex-auto flex md:justify-end justify-center pr-5 py-6'>
        <Button width={isLargeScreen ? 138 : '100%'} icon='arrowright' type='success' style={btnStyle} text='Continuar' onClick={submitCallback} />
      </div>
    </>
  )
}

export default ClientInformationForm
